import { Button } from '@trackman/web-shared-components';
import { OrderSummaryCardStatic } from '../OrderSummaryCards/OrderSummaryCardStatic/OrderSummaryCardStatic';
import './CartStepThree.scss';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DefaultRoutes } from 'Routes';
import { useEffect } from 'react';
import { useCartStore } from 'stores/Webshop/CartStore';
import { ReactComponent as Checkmark } from 'images/icons/Checkmark.svg';

export const CartStepThree = () => {
  const { t } = useTranslation();
  const resetCartStore = useCartStore((state) => state.reset);
  const orderCompletionDate = useCartStore((state) => state.orderCompletionDate);
  const orderEmail = useCartStore((state) => state.orderEmail);
  const invoiceNumber = useCartStore((state) => state.invoiceNumber);
  const navigate = useNavigate();

  useEffect(() => () => resetCartStore(), []);

  const formattedOrderDate = orderCompletionDate
    ?.toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZoneName: 'short',
    })
    .replace(/,([^,]*)$/, ' at$1');

  return (
    <>
      <div className='order'>
        <div className='order-details'>
          <h2>
            {t('ThanksForYourOrder', { ns: 'webshop' })}{' '}
            <div className='checkmark-icon'>
              <Checkmark />
            </div>
          </h2>

          <div>
            <Trans
              i18nKey='ConfirmationEmailSent'
              ns='webshop'
              values={{ email: orderEmail }}
              defaults='A confirmation email has been sent to <bold>{{email}}</bold>'
              components={{ bold: <strong /> }}
            ></Trans>
            <div>{t('CheckSpamFolder', { ns: 'webshop' })}</div>
          </div>
          <div>
            <Trans
              i18nKey='YourOrder'
              ns='webshop'
              values={{ orderNumber: invoiceNumber }}
              defaults='Your order: <bold>{{orderNumber}}</bold>'
              components={{ bold: <strong /> }}
            ></Trans>
            <div>
              <Trans
                i18nKey='PaymentDate'
                ns='webshop'
                values={{ paymentDate: formattedOrderDate }}
                defaults='Payment date: <bold>{{paymentDate}}</bold>'
                components={{ bold: <strong /> }}
              ></Trans>
            </div>
          </div>
        </div>
        <Button
          intent='primary'
          className='order-button'
          label={t('ExploreLearningHub', { ns: 'webshop' })}
          onClick={() => navigate(DefaultRoutes.LearningHub)}
        />
      </div>
      <div className='summary'>
        <OrderSummaryCardStatic />
      </div>
    </>
  );
};
